import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Registrar un producto.
 * @param payload: company_id, et_order_id, name, component, percentaje, language_id, producer_id, comment
 * @returns {Promise} Producto registrado
 * @autor Paul Valencia
 */
export async function createEtProduct({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post('et_products/create', payload);
        return Promise.resolve(response);
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Obtener los productos por empresa con paginación.
 * @param state.filter: company_id, order, page, per_page, sortBy, sort
 * @returns {Promise} lista de productos
 * @autor Paul Valencia
 */
export async function getProductsByCompany({commit, state}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('et_products', {params: state.filter});
        commit('setProductsCompany', response.data);
        if (!response.data.data.length) {
            await Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'No se encontraron productos',
                showConfirmButton: false,
                timer: 3000
            });
        }
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Obtiene el detalle del producto.
 * @param state.filter: id,company_id
 * @returns {Promise} Detalle del producto
 * @autor Paul Valencia
 */
export async function getProductDetails({commit}, {id, company_id}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`et_products/${id}/show`, {params: {company_id}});
        commit('setProduct', response.data)
    } catch (error) {
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}


/**
 * Actualizar una orden.
 * @param payload: id, order, start_date, quantity, company_id, comment, state
 * @returns {Promise} orden actualizada
 * @autor Paul Valencia
 */
export async function updateEtProduct({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`et_products/${payload.id}/update`, payload);
        commit('setProduct', response.data.data);
        commit('updateProduct', response.data.data);
        return Promise.resolve(response.data);
    } catch (error) {
        if (error.message) {
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

/**
 * Cambiar el estado de un producto a inactivo para simular la eliminación.
 *
 * @param payload: id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function deleteProduct(context, {id, company_id}) {

    await $http.patch(`et_products/${id}/delete`, {company_id}).then(async (response) => {

        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });

        return Promise.resolve(company_id);

    }).catch(async (error) => {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });

    return Promise.resolve(company_id);
}



/**
 * Obtener empresas filtro
 */
export async function getCompaniesFilter({commit, dispatch}, name) {
    dispatch('getCompaniesPetition', name)
        .then(empresas => {
            commit('setCompaniesFilter', empresas)
        });

}


/**
 * Obtener empresas filtro
 */
export async function getMyCompany({commit, dispatch}) {
    const companies = await dispatch('getMyCompanyPetition');
    commit('setCompaniesFilter', companies);
    return Promise.resolve(companies[0])
}


/**
 * Obtener empresas desde el back
 *
 * @param nombre
 * @return empresas backend
 * @author Paul
 */
export async function getCompaniesPetition({commit, state}, name) {

    return await new Promise(async (resolve, reject) => {
        if (!state.loading_data_select && name && name.length > 1) {
            commit('dashboard/load', true, {root: true});
            let parametros = {
                params: {
                    nombre: name
                }
            };
            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    resolve(response.data.data);
                    commit('dashboard/load', false, {root: true});
                })
                .catch(() => {
                    reject([]);
                    commit('dashboard/load', false, {root: true});
                });
        }
    });
}


/**
 * Obtener la empresa asociada desde el back
 *
 * @param nombre
 * @return empresas backend
 * @author Paul
 */
export async function getMyCompanyPetition({commit}) {

    return await new Promise(async (resolve, reject) => {
        commit('setLoadingDataSelect', true);
        await $http.get('/mi-empresa/lista')
            .then((response) => {
                resolve(response.data);
                commit('setLoadingDataSelect', false);
            })
            .catch(() => {
                reject([]);
                commit('setLoadingDataSelect', false);
            });
    });
}


/**
 * Encargado de autocomplete para fabricantes.
 * @param nombre
 * @returns void
 * @autor Paul Valencia
 */
export async function getManufacturersFilter({commit, dispatch}, name) {
    dispatch('getManufacturersPetition', name)
        .then(manufactures => commit('setManufacturerFilter', manufactures));
}


/**
 * Obtener fabricantes.
 * @param nombre
 * @returns fabricantes
 * @autor Paul Valencia
 */
export async function getManufacturersPetition({commit, state}, name) {

    return await new Promise(async (resolve, reject) => {
        if (!state.loading_data_select && name && name.length > 1) {
            commit('setLoadingDataSelect', true);

            let parametros = {
                params: {
                    nombre: name
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http.get('/fabricantes', parametros)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    commit('setLoadingDataSelect', false);
                    resolve(response.data.fabricantes);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    commit('setLoadingDataSelect', false);
                    reject([]);
                });
        }
    });
}




